import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';
import {
  ImageShowcaseContainer,
  ImageShowcaseWrapper,
  ImageSlideBlocksListContainer,
  ImageSlidesWithProgressContainer,
} from './ImageSlideWithProgress.styles';
import ImageSlideTextBlock from './ImageSlideTextBlock';

export interface ISlideImage {
  image: IGatsbyImageData;
  title: string;
  description: string;
}

interface ImageSlideWithProgressProps {
  slideDuration?: number;
  slides: ISlideImage[];
  slideLayout?: 'default' | 'fullWidth';
}

const ImageSlideWithProgress = ({
  slides,
  slideDuration = 5000,
  slideLayout = 'default',
}: ImageSlideWithProgressProps): JSX.Element => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => setCurrentSlideIndex((prevIndex) => (prevIndex + 1) % slides.length), 5000);

    return () => clearTimeout(timeout);
  }, [currentSlideIndex]);

  return (
    <ImageSlidesWithProgressContainer>
      <ImageShowcaseWrapper>
        {slides.map((slide, index) => (
          <ImageShowcaseContainer
            key={index}
            className='image-showcase-container'
            currentSlide={index === currentSlideIndex}
            slideLayout={slideLayout}
          >
            <GatsbyImage
              image={slide.image}
              alt={slide.title}
            />
          </ImageShowcaseContainer>
        ))}
      </ImageShowcaseWrapper>
      <ImageSlideBlocksListContainer>
        {slides.map((slide, index) => (
          <ImageSlideTextBlock
            key={index}
            title={slide.title}
            description={slide.description}
            active={index === currentSlideIndex}
            onSlideClick={() => setCurrentSlideIndex(index)}
            slideDuration={slideDuration}
          />
        ))}
      </ImageSlideBlocksListContainer>
    </ImageSlidesWithProgressContainer>
  );
};

export default ImageSlideWithProgress;
